import React from 'react';
import {
  number,
  oneOfType,
  string,
} from 'prop-types';

/**
 * Please dont use this, use NumberFormat instead
 * @deprecated
 * @param props
 * @returns {*}
 * @constructor
 */
const Currency = (props) => {
  const {
    value,
    currencyText,
  } = props;

  const formatCurrency = (val, currency) => `${currency}${val.toLocaleString()}`;

  return (
    <span>
      { formatCurrency(value, currencyText) }
    </span>
  );
};

Currency.propTypes = {
  value: oneOfType([number, string]).isRequired,
  currencyText: string,
};

Currency.defaultProps = {
  currencyText: 'HK$',
};

export default Currency;
